import { render, staticRenderFns } from "./basic-setting.vue?vue&type=template&id=98a869f4&"
import script from "./basic-setting.vue?vue&type=script&lang=js&"
export * from "./basic-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports